import HttpRequest from "../http_request";
class ReportApi extends HttpRequest {
  apiGetTransection(data) {
    return this.fetch(`/client/v1/reports/wallet-transactions`, data);
  }
  apiGetloadTransectionCOD(data) {
    return this.fetch(`/client/v1/reports/cod-wallet-transactions`, data);
  }
  apiGetRefillWallet(data) {
    return this.fetch(`/client/v2/topup-approvals`, data);
  }
  apiGetReportCod(data) {
    return this.fetch(`/client/v1/reports/cod`, data);
  }
  apiGetReportPickup(data) {
    return this.fetch(`/client/v1/reports/pickup`, data);
  }
  apiGetReportAffiliate(data) {
    return this.fetch(`/client/v1/reports/affiliate`, data);
  }
  apiGetKeyConnect(){
    return this.fetch(`/client/v1/api-key`)
  }
  apiGetgetCodApprove(data){
    return this.fetch(`/client/v1/wallet/cod-approvals`,data)
  }
  apiGetCodApproveByid(id){
    return this.fetch(`/client/v1/wallet/cod-approvals/${id}`)
  }
  apiGetParceShipmentCod(id){
    return this.fetch(`/client/v1/wallet/cod-approvals/${id}/shipment-orders`)
  }
  apiGetCodOrder(data){
    return this.fetch(`/client/v2/reports/shipment-orders/cod`,data)
  }
  apiGetCodOrderSummary(data){
    return this.fetch(`/client/v2/reports/shipment-orders/cod/summary`,data)
  }
  apiGetCodOrderSummaryMoney(data){
   return this.fetch(`/client/v1/reports/shipment-orders/cod/summary-amount`,data) 
  }
  apiGetHistoryInsurance(data) {
    return this.fetch(`/client/v1/wallet-service-transactions`, data);
  }

}

export default ReportApi;
